export interface VersionInfo {
  version: string // Full commit SHA
  commit: string // Full commit SHA
  branch: string // Git branch
  buildTime: string // Build timestamp
  commitMessage: string // Latest commit message
  tag?: string // Git tag if available
  pipeline?: string // CI pipeline ID
  environment?: string // Current environment
}

export function getVersionInfo(): VersionInfo {
  return {
    version: import.meta.env.VITE_COMMIT_HASH || 'unkown',
    commit: import.meta.env.VITE_COMMIT_HASH || 'unknown',
    branch: import.meta.env.VITE_BRANCH || 'unknown',
    buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString(),
    commitMessage: import.meta.env.VITE_COMMIT_MESSAGE || '',
    tag: import.meta.env.VITE_GIT_TAG || undefined,
    pipeline: import.meta.env.VITE_PIPELINE_ID || undefined,
    environment: import.meta.env.VITE_ENVIRONMENT || 'unknown',
  }
}

export function logVersionToConsole(): void {
  const info = getVersionInfo()
  console.info(
    '%cOptiStream Frontend',
    'font-weight: bold; font-size: 14px;',
    '\n Version (Full Hash):',
    info.version,
    '\n Branch:',
    info.branch,
    '\n Commit:',
    info.commitMessage,
    '\n Built:',
    info.buildTime,
    '\n Environment:',
    info.environment || 'local',
  )
}

export function formatVersionString(info: VersionInfo): string {
  // Use first 7 characters of full hash for display
  const shortVersion = info.version.substring(0, 7)
  return `${shortVersion} (${info.branch})`
}
